
   
    <div class="uk-child-width-1-1@s" uk-grid>
        <div>
            <div class="uk-background-cover uk-height-large uk-panel uk-flex-center uk-flex-middle"
                   style="background-image: url(../../assets/swiftbanner.png);">
                <div class="uk-section uk-light">
                    <div class="uk-container-small uk-width-2xlarge" style="padding-top: 20px;">
                        <div><h1 class="uk-text-bold uk-padding-large uk-padding-remove-vertical"  style="margin-bottom: 10px;">Swift Application Development</h1></div>
                        <div>
                            <p class="uk-padding-large uk-text-left  uk-padding-remove-vertical" style= "font-size: 20px;">It’s high time to
                                 make the switch to the more approachable, feature-rich  Swift for all your custom iOS app development.
                                  Don’t get too tired in searching. WebSoulLabs is here to serve you the best. 
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="uk-section uk-section-default" style="padding-top: 55px;">
        <div class="uk-container">
            
                
                <h2 class="uk-text-center " style="margin-bottom: 30px; font-weight: 600;"> Go deeper in Swift </h2>
            <div class="uk-column-1-2@s">
                
                <p class="uk-text-medium uk-text-justify" style="font-size: 18px;">Swift is a powerful and 
                    effective programming language for macOS, iOS, watchOS and beyond. Writing Swift code
                     is interactive and fun, short and crisp yet expressive, and Swift includes modern
                      features developers love. Swift is the perfect begining point for learning to create 
                      apps that run on iPhone and iPad. When it comes to custom iOS app development, the
                       developers always have to analyze, evaluate and work on the new strategies that is
                        opted according to the customer ideas. We establish a new level of interactivity 
                        in our custom iPhone app development. Swift consists of a number of useful features
                         which makes Swift a lot easier to use and it also simplifies other common patterns.
                   </p>
                <div>
                    <img data-src="assets/swift1.jpg" width="600" height="600" alt="swift pics" uk-img>
                </div>
            </div>
            <br>
            <div class="uk-column-1-2@s">
                <div>
                    <img data-src="assets/swift2.jpg" width="600" height="600" alt="swift pics" uk-img>
                </div>
                <p class="uk-text-medium uk-text-justify" style="font-size: 18px;">In simple words, Swift 
                    combines features of both C and Objective-C programming language without having direct
                     built-in C similarity and all constraints that comes along with it. Furthermore, iOS 
                     app developers can completely rearrange  their custom iOS app development using Cocoa 
                     and Cocoa Touch in Swift. Swift is gaining popularity very quickly. It is a very  
                     rapidly-growing programming language. In fact, more and more big brands are implementing
                      Swift code into their iOS mobile applications.After Swift’s big reveal, there was a lot 
                      of confusion in the development community as well as among technology startups and
                       Enterprises that whether Swift is the better programming language or not. 
                </p>
               
            </div>
        </div>  <!--container div-->

        <div class="uk-container uk-container-expand">
            <h1 class="uk-padding-small uk-text-center " style="margin-bottom: 0px; color: #fff; padding-bottom: 35px; font-weight: 600;">Swift App Service </h1>
            <div class="ws-services  uk-child-width-1-2@s uk-child-width-1-3@m uk-flex-center uk-padding uk-light uk-grid-match" style="padding-bottom: 0px; padding-top: 0px; margin-bottom: 15px; margin-top: 15px;" uk-grid>
                
                <div>
                    <div class="uk-placeholder uk-text-center uk-panel uk-padding" style="padding-top:10px;" >
                        
                        <img class="uk-align-center" style="margin-bottom: 10px;" src="assets/api1.png" width="68" height="68" alt="border-circle">
                            
                        
                        <h3 style="margin-bottom: 10px; margin-top: 0px;"><strong>Getting access to APIs</strong></h3>
                        <p class="uk-text-center uk-text-justify" style="color: snow; margin-top: 10px;"> Our skilled development team delivers customized and 
                            end to end solutions starting from conceptualization to implementation at cost-effective rates.</p>
                    </div>
                </div>
                <div>
                    <div class="uk-placeholder uk-text-center uk-panel uk-padding"  style="padding-top:15px;">
                        
                        <img class=" uk-align-center" style="margin-bottom: 10px;" src="assets/pl1.png" width="68" height="68" alt="border-circle">
                            
                        
                        <h3 style="margin-bottom: 10px; margin-top: 0px;"><strong>Parameter Labelling</strong></h3>
                        <p class="uk-text-center uk-text-justify" style="color: snow; margin-top: 10px; word-spacing: -5px;letter-spacing: 1px;">Swift is a powerful 
                            tool that allows developers to create versatile applications for multiple operating systems. 
                        </p>
                    </div>
                </div>
                <div>

                    <div class="uk-placeholder uk-text-center uk-panel uk-padding"  style="padding-top:15px;">
                        <img class=" uk-align-center"  style="margin-bottom: 10px;" src="assets/su1.png" width="65" height="65" alt="border-circle">
                            
                        <h3 style="margin-bottom: 10px; margin-top: 0px;"><strong>Playground Support</strong></h3>
                        <p class="uk-text-center uk-text-justify" style="color: snow; margin-top: 10px;">There are alot of E-commerce App Template 
                            for developers, students, and iOS beginners, who can use it to learn how to build a shopping app in Swift. 
                        </p>
                    </div>
                </div>
                <div>
                    <div class="uk-placeholder uk-text-center uk-panel uk-padding"  style="padding-top:15px;">
                        <img class="uk-align-center" style="margin-bottom: 5px;" style="margin-bottom: 0px;" src="assets/g1.png" width="68" height="68" alt="border-circle">
                           
                               
                        
                        <h3 style="margin-bottom: 10px; margin-top: 0px;"><strong>Generics</strong></h3>
                        <p class="uk-text-center uk-text-justify" style="color: snow; margin-top: 10px;">Health and fitness apps are well 
                            developed using Swift, gives all the health  details and directions to maintain a healthy life .</p>
                    </div>
                </div>
                
                <div>
                    <div class="uk-placeholder uk-text-center uk-panel uk-padding"  style="padding-top:15px;">

                        <img class="uk-align-center"  style="margin-bottom: 10px;" src="assets/war.png" width="60" height="60" alt="border-circle">
                            
                        
                        <h3 style="margin-bottom: 10px; margin-top: 0px;" ><strong>Warnings</strong></h3>
                        <p class="uk-text-center uk-text-justify" style="color: snow; margin-top: 10px;">Communications and data sharing 
                            via social networking apps are made very much efficiently and attractive using Swift.
                        </p>
                    </div>
                </div>
                
                <div>
                    <div class="uk-placeholder uk-text-center uk-panel uk-padding"  style="padding-top:15px;">
                        <img class=" uk-align-center" style="margin-bottom: 10px;" src="assets/test.png" width="60" height="60" alt="border-circle">
                            
                        
                        <h3 style="margin-bottom: 10px; margin-top: 0px;"><strong>App testing and porting</strong></h3>
                        <p class="uk-text-center uk-text-justify" style="color: snow; margin-top: 10px;">verifies software behavior
                             and improves the quality of the code. Porting  apps from Android to iOS and iOS to android
                              and made easy.
                        </p>
                    </div>
                </div>
            </div>
        </div>
        
        <h1 class="uk-text-center" style="margin-bottom: 0px;"><span>Related Services</span></h1>
        <BR><BR>
            
            <div class="uk-container">
                <div class="uk-grid-small  uk-child-width-1-2@s uk-child-width-1-4@m  uk-flex-center uk-grid-match" uk-grid>
                    <div>
                        <div class="uk-box-shadow-xlarge uk-box-shadow-hover-medium" style="padding-top: 30px;">
                           
                            <img class=" uk-align-center" src="assets/icons/ig1.png" width="100" height="100" alt="">
                            <h4 class="uk-text-center" style="font-weight:600">IPhone App<br> Development</h4>
                    
                        </div>
                    </div>
                   
                    <div>
                        <div class="uk-box-shadow-xlarge uk-box-shadow-hover-medium " style="padding-top: 30px;">
                            <img class="uk-border-pill uk-align-center" src="assets/icons/mobileg1.png" width="100" height="100" alt="">
                            <h4 class="uk-text-center" style="font-weight:600">Mobile App<br> Development</h4>
                        
                        
                        </div>
                    </div>
                  
            
                    <div>
                        <div class="uk-box-shadow-xlarge uk-box-shadow-hover-medium" style="padding-top: 30px;">
                            <img class=" uk-align-center" src="assets/icons/gapg1.png" width="100" height="100" alt="">
                            <h4 class="uk-text-center" style="font-weight:600">PhoneGap App<br> Development</h4>
                        </div>
                    </div>
            
                    <div>
                   
                        <div class="uk-box-shadow-xlarge uk-box-shadow-hover-medium" style="padding-top: 30px;">
                            <img class=" uk-align-center" src="assets/icons/xamaring10.png" width="100" height="100" alt="">
                            <h4 class="uk-text-center" style="font-weight:600">Xamarin App<br> Development</h4>
            
                       
                        </div>
                    </div>
            
                    <div>
                        <div class="uk-box-shadow-xlarge uk-box-shadow-hover-medium" style="padding-top: 30px;">
                            <img class=" uk-align-center" src="assets/icons/cross.png" width="100" height="100" alt="">
                            <h4 class="uk-text-center" style="font-weight:600">Cross Platform App Development</h4>
            
                       
                        </div>
                    </div>
            
                   
                    <div>
                        <div class="uk-box-shadow-xlarge uk-box-shadow-hover-medium"  style="padding-top: 30px;">
                            <img class=" uk-align-center" src="assets/icons/androigg13.png" width="100" height="100" alt="">
                            <h4 class="uk-text-center" style="font-weight:600">Android App<br> Development</h4>
            
                        </div>
                    </div>
                   
                </div>
               
    
            </div>
        <h1 class="uk-text-center"><span>Technology Stack</span></h1>
    <br>
    <div class="uk-container">
        <div class=" wss uk-child-width-1-2@s uk-child-width-1-4@m uk-grid-match" uk-grid>
            <div>
                <div class="uk-placeholder uk-text-center uk-panel uk-padding">
                    <img class="uk-border-circle uk-align-center" src="assets/swi.jpg" width="90" height="90"
                        alt="border-circle">
                    <h4  style="font-weight: 600;">Swift</h4>
                </div>
            </div>
            <div>
                <div class="uk-placeholder uk-text-center uk-panel uk-padding">
                    <img class="uk-border-circle uk-align-center" src="assets/and.png" width="90" height="90"
                        alt="border-circle">
                    <h4  style="font-weight: 600;">Android</h4>
                </div>
            </div>
            <div>
                <div class="uk-placeholder uk-text-center uk-panel uk-padding">
                    <img class="uk-border-circle uk-align-center" src="assets/java.jpg" width="90" height="90"
                        alt="border-circle">
                    <h4  style="font-weight: 600;">Java</h4>
                </div>
            </div>
            <div>
                <div class="uk-placeholder uk-text-center uk-panel uk-padding">
                    <img class="uk-border-circle uk-align-center" src="assets/apple.png" width="90" height="90"
                        alt="border-circle">
                    <h4  style="font-weight: 600;">Ios</h4>
                </div>
            </div>
        </div>
        <div class="wss uk-child-width-1-2@s uk-child-width-1-4@m uk-margin-large uk-grid-match" uk-grid>
            <div>
                <div class="uk-placeholder uk-text-center uk-panel uk-padding">
                    <img class="uk-border-circle uk-align-center" src="assets/kotlin.jpg" width="90" height="90"
                        alt="border-circle">
                    <h4  style="font-weight: 600;">Kotlin</h4>
                </div>
            </div>
            <div>
                <div class="uk-placeholder uk-text-center uk-panel uk-padding">
                    <img class="uk-border-circle uk-align-center" src="assets/Fabric.jpg" width="85" height="85"
                        alt="border-circle">
                    <h4  style="font-weight: 600;">Fabric</h4>
                </div>
            </div>
            <div>
                <div class="uk-placeholder uk-text-center uk-panel uk-padding">
                    <img class="uk-border-circle uk-align-center" src="assets/xamarin.png" width="90" height="90"
                        alt="border-circle">
                    <h4  style="font-weight: 600;">Xamarin</h4>
                </div>
            </div>
            <div>
                <div class="uk-placeholder uk-text-center uk-panel uk-padding">
                    <img class="uk-border-circle uk-align-center" src="assets/React.webp" width="90" height="90"
                        alt="border-circle">
                    <h4  style="font-weight: 600;">React Js</h4>
                </div>
            </div>
        </div>
        <div class="wss uk-child-width-1-2@s uk-child-width-1-4@m uk-margin-large uk-grid-match" uk-grid>
            <div>
                <div class="uk-placeholder uk-text-center uk-panel uk-padding">
                    <img class="uk-border-circle uk-align-center" src="assets/appt.png" width="90" height="90"
                        alt="border-circle">
                    <h4  style="font-weight: 600;">Appcelerator Titanium</h4>
                </div>
            </div>
            <div>
                <div class="uk-placeholder uk-text-center uk-panel uk-padding">
                    <img class="uk-border-circle uk-align-center" src="assets/flutter.png" width="80" height="80"
                        alt="border-circle">
                    <h4  style="font-weight: 600;">Flutter</h4>
                </div>
            </div>
            <div>
                <div class="uk-placeholder uk-text-center uk-panel uk-padding">
                    <img class="uk-border-circle uk-align-center" src="assets/back.png" width="130" height="130"
                        alt="border-circle">
                    <h4  style="font-weight: 600;">Backbone</h4>
                </div>
            </div>
            <div>
                <div class="uk-placeholder uk-text-center uk-panel uk-padding">
                    <img class="uk-border-circle uk-align-center" src="assets/ember.png" width="90" height="90"
                        alt="border-circle">
                    <h4  style="font-weight: 600;">Ember</h4>
                </div>
            </div>
        </div>
    </div>
    <br>



    </div>  <!--div after banner-->


    